import getWinningDimensions, {
  getFirstNWinners,
  getDimensionItems
} from './dimensions';

export { getWinningDimensions, getFirstNWinners, getDimensionItems };
export default getWinningDimensions;
